// extracted by mini-css-extract-plugin
export default {"heading-primary":"Component_heading-primary__QH-Av","component":"Component_component__8rieD","component--padding":"Component_component--padding__3NHbd"};